import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiInterface } from '../api-interface';
import { Observable } from 'rxjs';
import { UsuarioContextoDTO, UsuarioCreateDTO, UsuarioDTO, UsuarioResponseDTO, UsuarioUpdateDTO } from '../../models/usuario.model';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<UsuarioResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<UsuarioResponseDTO>(path);
  }

  getById<T>(url: string): Observable<UsuarioDTO> {
    return this.apiService.read<UsuarioDTO>(url);
  }

  /** Retorna o usuário com campos de contexto de autenticação (categoriaAdmin, empresaId, etc.) */
  getContexto(url: string): Observable<UsuarioContextoDTO> {
    return this.apiService.read<UsuarioContextoDTO>(url);
  }

  post<T>(url: string, data: UsuarioCreateDTO): Observable<UsuarioDTO> {
    return this.apiService.create<UsuarioDTO>(url, data);
  }

  put<T>(url: string, data: UsuarioUpdateDTO): Observable<UsuarioDTO> {
    return this.apiService.update<UsuarioDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  /** PUT /usuario/atualizarSenha/{id} — atualiza apenas a senha do usuário */
  atualizarSenha(id: number, senha: string): Observable<string> {
    return this.apiService.updateText(`/usuario/atualizarSenha/${id}`, { senha });
  }

  /** PUT /usuario/ativarOuInativar/{id}/status/{ativo} — sem body */
  ativarOuInativar(id: number, ativo: boolean): Observable<string> {
    return this.apiService.updateText(`/usuario/ativarOuInativar/${id}/status/${ativo}`);
  }
}
